import React from 'react';
import DeviceSchema from '../../Components/DeviceSchema/DeviceSchema';
import ConfigAnalyzer from "../../../Utils/ConfigAnalyzer";
import './Diagnostic.css';
import NoDataPlaceholder from "../../Components/NoDataPlaceholder/NoDataPlaceholder";

let instance = null;

/**
 * Vue de diagnostic : retient les boîtiers actifs et valides, puis affiche
 * le schéma technique de l'installation sélectionnée.
 * @typedef {Object} DiagnosticProps
 * @property {import('../../../Models/DomainTypes').PayStation[]} payStations Installations visibles après filtrage.
 * @property {import('../../../Models/DomainTypes').EntityId | null} [selected] Identifiant du boîtier initial.
 * @property {number | null} [selectedDevice] Identifiant numérique de l'appareil initial.
 * @property {import('../../../Utils/UserDataManager').default | null} [user]
 * @property {{ graphql: Function }} API
 * @property {string} locale
 * @property {boolean} isDarkStyle
 * @property {boolean} isDesktop
 * @property {unknown} [technicalData] Donnée initiale conservée dans l'état local.
 */

/** @extends {React.Component<DiagnosticProps>} */
class Diagnostic extends React.Component {
	constructor( props ) {
		super( props );
		this.state = {
			technicalData:props.technicalData
		};
		instance = this;
	}

	onNewTechnicalData( technicalData ) {
		instance.setState({
			technicalData:technicalData
		});
	}

	render() {
		const boxes = [];
		const analyzer = new ConfigAnalyzer( this.props.payStations );
		this.props.payStations?.forEach( payStation => {
			if( analyzer.isActiveBoxAtSearchTime( payStation ) && analyzer.isValid( payStation ) ) {
				boxes.push( payStation.box );
			}
		} );

		if ( ! boxes  || boxes.length < 1 ) {
			return (<NoDataPlaceholder className="comparison-placeholder-no-data" shown={true}/>);
		}

		return (
			<React.Fragment>
				<DeviceSchema isDarkStyle={this.props.isDarkStyle}
							  locale={this.props.locale}
							  boxList={boxes}
							  selected={this.props.selected}
							  selectedDevice={this.props.selectedDevice}
							  payStations={this.props.payStations}
							  isDesktop={this.props.isDesktop}
							  user={this.props.user}
							  API={this.props.API} />
			</React.Fragment>
		);
	}
}

export default Diagnostic;
